import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { TaskScreenStyles } from "./TaskScreenStyles";

const CompletedTaskBox = ({ handleOptionClick, count }) => {
  return (
    <Box sx={TaskScreenStyles()?.taskCardContainer}>
      <Box sx={TaskScreenStyles()?.completedTaskCardSubbContainer}>
        <HStack sx={TaskScreenStyles()?.completedTaskBox}>
          <VStack sx={TaskScreenStyles()?.taskCardSection}>
            <Text sx={TaskScreenStyles()?.optionTitleTaskCardSection}>
              Completed
            </Text>
            <Text sx={TaskScreenStyles()?.completedCountText}>
              You have completed {count}{" "}
              {count === 0 || count === 1 ? `homework` : `homeworks`}
            </Text>
          </VStack>
          <Box
            onClick={() => {
              handleOptionClick({
                name: "Completed",
                value: "completed",
              });
            }}
            sx={TaskScreenStyles()?.completedViewList}
          >
            View List
          </Box>
        </HStack>
      </Box>
    </Box>
  );
};

export default CompletedTaskBox;
